import { useEffect, useState } from "react";
import { api, brl } from "@/lib/api";
import { ChevronLeft, ChevronRight, Wallet, Clock, TrendingUp, Hash } from "lucide-react";

const monthLabel = (m) => { const [y, mm] = m.split("-"); return new Date(Number(y), Number(mm) - 1, 1).toLocaleDateString("pt-BR", { month: "long", year: "numeric" }); };
const shift = (m, n) => { const [y, mm] = m.split("-").map(Number); const d = new Date(y, mm - 1 + n, 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

function Card({ label, value, icon: Icon, color, testid }) {
  return (
    <div data-testid={testid} className="rounded-2xl lg:rounded-xl border border-card2-border bg-card2 p-4 lg:p-3 flex items-center gap-3">
      <span className="h-10 w-10 lg:h-8 lg:w-8 rounded-xl lg:rounded-lg inline-flex items-center justify-center shrink-0" style={{ background: `${color}22`, color }}><Icon className="h-5 w-5 lg:h-4 lg:w-4" /></span>
      <div className="min-w-0"><div className="text-[11px] font-mono-caps text-zinc-500 truncate">{label}</div><div className="font-display text-2xl lg:text-xl font-black truncate" style={{ color }}>{value}</div></div>
    </div>
  );
}

export function FinanceOverviewCards() {
  const [m, setM] = useState(() => new Date().toLocaleDateString("sv-SE").slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/erp/finance/overview", { params: { month: m } }).then(({ data }) => setD(data)).catch(() => setD(null)); }, [m]);
  const v = (x) => (d ? brl(x) : "…");
  return (
    <section data-testid="finance-overview" className="space-y-2">
      <div className="flex items-center justify-center gap-2">
        <button type="button" data-testid="finance-overview-prev" onClick={() => setM(shift(m, -1))} aria-label="Mês anterior" className="h-9 w-9 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 inline-flex items-center justify-center hover:bg-zinc-800"><ChevronLeft className="h-4 w-4" /></button>
        <span data-testid="finance-overview-month" className="font-mono-caps uppercase text-sm text-zinc-200 min-w-[11rem] text-center">{monthLabel(m)}</span>
        <button type="button" data-testid="finance-overview-next" onClick={() => setM(shift(m, 1))} aria-label="Próximo mês" className="h-9 w-9 rounded-md bg-zinc-900 border border-zinc-800 text-zinc-300 inline-flex items-center justify-center hover:bg-zinc-800"><ChevronRight className="h-4 w-4" /></button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Card testid="finance-card-received" label="Recebido" value={v(d?.received)} icon={Wallet} color="#22c55e" />
        <Card testid="finance-card-receivable" label="A receber" value={v(d?.receivable)} icon={Clock} color="#f87171" />
        <Card testid="finance-card-revenue" label="Receita" value={v(d?.revenue)} icon={TrendingUp} color="#fb923c" />
        <Card testid="finance-card-count" label="Qtd. no mês" value={d ? d.count : "…"} icon={Hash} color="#60a5fa" />
      </div>
    </section>
  );
}
